export default function KpiStrip({ stats }) {
  if (!stats) return null;
  const items = [
    { k: "total", label: "Targets", sub: `${stats.high} high-fit`, glow: "rgba(245,158,11,0.25)" },
    { k: "sent", label: "Sent", sub: `${stats.pendingPreAde} still to send`, glow: "rgba(56,189,248,0.25)" },
    { k: "replied", label: "Replied", sub: `${stats.replyRate}% reply rate`, glow: "rgba(251,191,36,0.25)" },
    { k: "meetings", label: "Meetings booked", sub: "ADE week", glow: "rgba(52,211,153,0.25)" },
    { k: "followUpsDue", label: "Follow-ups due", sub: "post-ADE", glow: "rgba(168,85,247,0.25)" },
  ];
  return (
    <div className="grid grid-cols-2 md:grid-cols-5 gap-3" data-testid="kpi-strip">
      {items.map((it, i) => (
        <div key={it.k} className="card kpi rise" style={{ "--kpi-glow": it.glow, animationDelay: `${i * 60}ms` }} data-testid={`kpi-${it.k}`}>
          <div className="eyebrow">{it.label}</div>
          <div className="num mt-2" data-testid={`kpi-${it.k}-value`}>{stats[it.k]}</div>
          <div className="text-xs mt-1" style={{ color: "var(--text-2)" }}>{it.sub}</div>
        </div>
      ))}
    </div>
  );
}
